module.exports = __webpack_public_path__ + "img/wechat_pay_logo.061329fc.svg";